<button
  mat-button
  [attr.id]="id"
  [attr.name]="name"
  [attr.value]="value"
  [disabled]="disabled"
  [className]="style + '-btn'"
  [ngClass]="{ ignoreHover: ignoreHover }"
  (click)="click($event)"
>
  @if (iconName && iconFirst) {
  <span class="icon icon-first" [ngClass]="{ 'icon-stroke': iconStroke }">
    <firebird-web-icon
      [name]="iconName"
      width="14px"
      height="14px"
    ></firebird-web-icon
  ></span>
  }
  <span class="label" [translate]="labelKey"></span>
  @if (iconName && !iconFirst) {
  <span class="icon" [ngClass]="{ 'icon-stroke': iconStroke }"
    ><firebird-web-icon
      [name]="iconName"
      [width]="iconWidth || '12px'"
      [height]="iconHeight || '12px'"
    ></firebird-web-icon
  ></span>
  }
  <ng-content></ng-content>
</button>
